var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "misc-wrapper" },
    [
      _c("b-link", { staticClass: "brand-logo main__logo__title" }, [
        _c("img", {
          attrs: { src: require("../../assets/images/logo/logo.svg"), alt: "" },
        }),
        _c("h2", { staticClass: "brand-text ml-1 title" }, [
          _vm._v(" Enterprise"),
          _c("br"),
          _c("span", { staticClass: "title_go" }, [_vm._v("GoDigital")]),
        ]),
      ]),
      _c("div", { staticClass: "misc-inner p-2 p-sm-3" }, [
        _c(
          "div",
          { staticClass: "w-100 text-center" },
          [
            _c("h2", { staticClass: "mb-1" }, [_vm._v(" Unauthorized! 🔐 ")]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(" You do not have permission to access this page. "),
            ]),
            _c("b-img", {
              attrs: { fluid: "", src: _vm.imgUrl, alt: "Not authorized page" },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }